import {
  Box,
  Button,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import { Checkbox } from "@ofqual/portal-components/components/Checkbox";
import React, { useState } from "react";
import { RecipientPotentiallyUnknownOrg } from "../../../../../domain/RecipientsViewModel";
import { ManageRecipientUsers } from "./ManageRecipientUsers";
import { OrgAction } from "./reducer";
import { AddUserDialog } from "./AddUserDialog";
import { Warning } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  checkbox: {
    padding: 0,
    margin: 0,
  },
  warning: {
    color: theme.palette.grey[700],
  },
}));

type ManageRecipientOrgProps = {
  org: RecipientPotentiallyUnknownOrg;
  dispatch: React.Dispatch<OrgAction>;
  haveRoles: boolean;
};

export const ManageRecipientOrg: React.FC<ManageRecipientOrgProps> = ({
  org,
  dispatch,
  haveRoles,
}) => {
  const classes = useStyles();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleFlagChange = () => {
    const nextValue = !org.isToDelete;
    dispatch({
      type: "FLAG_ORG",
      payload: { orgId: org.id, isToDelete: nextValue },
    });
  };

  const handleAddUser = (user: { id: string; upn: string }) => {
    dispatch({
      type: "ADD_USER",
      payload: {
        orgId: org.id,
        user,
      },
    });
  };

  const haveUsers = !!org.users.length;
  const labelId = `checkbox-list-label-${org.id}`;
  return (
    <React.Fragment>
      <ListItem dense role={undefined} button onClick={handleFlagChange}>
        <ListItemIcon>
          <Checkbox
            className={classes.checkbox}
            edge="start"
            checked={!!org.isToDelete}
            onChange={handleFlagChange}
            inputProps={{ "aria-labelledby": labelId }}
          />
        </ListItemIcon>

        <ListItemText
          id={labelId}
          primary={
            <RecipientOrgName
              name={org.name}
              showWarning={!haveRoles && !haveUsers}
            />
          }
        ></ListItemText>
        <ListItemSecondaryAction>
          <Button
            color="primary"
            onClick={() => setIsDialogOpen(true)}
            data-test="manage-recipients-select-users"
          >
            Select users
          </Button>
        </ListItemSecondaryAction>
      </ListItem>
      <ManageRecipientUsers org={org} users={org.users} dispatch={dispatch} />
      {isDialogOpen && (
        <AddUserDialog
          org={org}
          onClose={() => setIsDialogOpen(false)}
          onSelect={(val) => handleAddUser(val)}
        />
      )}
    </React.Fragment>
  );
};

const RecipientOrgName: React.FC<{ name: string; showWarning: boolean }> = ({
  name,
  showWarning,
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap">
      <span>{name}&nbsp;&nbsp;</span>
      {showWarning ? (
        <>
          <Warning fontSize="small" className={classes.warning} />

          <em className={classes.warning}>add at least one role or user</em>
        </>
      ) : null}
    </Box>
  );
};
